import React from "react";
import useTranslation from "../CustomHooks/useTranslation";
import { inputFieldContent } from "../inputfields/InputFieldContent";

interface RadioButtonProps {
  options: { id: string; label: string; testID?: string }[];
  selected: string;
  onChange: (value: string) => void;
  dir?: string;
  padding?: string;
  gapClassName?: string;
  isDisabled?: string[];
  extraClasses?: string;
  textClasses?: string;
}


const CustomRadioButton: React.FC<RadioButtonProps> = ({
  options,
  selected,
  onChange,
  gapClassName,
  padding,
  isDisabled,
  dir = "ltr",
  extraClasses,
  textClasses,
}) => {
  const { translate } = useTranslation(inputFieldContent);
  return (
    <div className={`flex flex-wrap ${extraClasses} ${gapClassName ? gapClassName : 'gap-[20px]'} `} dir={dir}>
    {options.map((option) => (
      <label key={option.id} data-testid={option.testID || option.id} className={`flex items-center ${isDisabled?.includes(option.id) ? 'cursor-not-allowed' : ' cursor-pointer'} ${padding ? padding : 'p-3'}`}>
        <input
          type="radio"
          value={option.id}
          checked={selected === option.id}
          onChange={() => onChange(option.id)}
          className="hidden"
          disabled={isDisabled && isDisabled.includes(option.id)}
        />
        <div
          className={`w-5 h-5 rounded-full flex items-center justify-center border-2 transition-colors duration-200 ${
            selected === option.id
              ? "border-p_primary"
              : "border-gray-200"
          }`}
        >
          {selected === option.id && (
            <div className="w-3 h-3 rounded-full bg-p_primary" />
          )}
        </div>
        <span className={`${dir === 'rtl' ? 'mr-2' : 'ml-2'} ${textClasses || 'text-body1'} ${isDisabled?.includes(option.id) ? 'text-secondary_text ' : 'text-primary_text'}`}>{translate(option.label)}</span>
      </label>
    ))}
  </div>
  );
};
export default CustomRadioButton;

